const zh = {
	list: {
		pending: '待处理',
		close: '已处理',
		disputeId: '争议单号',
		originId: '网站订单号',
	    omniOriginId: '商户订单号',
		nocases: '暂无数据',
		disputeId: '争议单号',
		originalOrderIDWebsite: '网站订单号/网站',
		websiteOrGroup: '网站/群组',
		omniWebsiteOrGroup: '门店/网站/群组',

		creationTime: '争议时间',
		time: '时间',
		deadline: '处理截止时间',
		completeTime: '处理时间',
		amount: '争议金额',
		reason: '原因'
	},
	detail: {
		disputeDetail: '争议详情',
		cardAssociation: '卡组织',
		orderDetail: '原始订单信息',
		websiteURL: '网站URL',
		transactionID: '交易流水号',
		itemName: '货运信息',
		amount: '交易金额',
		transactionTime: '原始交易时间',
		shippingName: '收货人姓名',
		clientEmail: '用户邮箱',
		shippingPhoneNumber: '收货人联系电话',
		process: '处理记录',
		required: '该项为必填项',
		processedOptions: [
			'已联系消费者，联系不上',
			'已联系消费者，诉求无理',
			'已联系消费者，已解决'
		],
		commentLog: '备注记录',
		processed: '已处理',
		pleaseSelect: '请选择',
		comment: '备注',
		cancel: '取 消',
		confirm: '确 定',
		successful: '操作成功',
		failure: '操作失败'
	}
}

export default zh
